import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useAuth0 } from '@hooks/useAuth0';
import { analytics } from '@services/analytics';

/**
 * Identifies the current user and tracks page views.
 */
export function Analytics() {
  const { user } = useAuth0();
  const location = useLocation();

  // Identify the user
  useEffect(() => {
    if (user?.email) {
      const [firstName, ...lastNames] = (user.name ?? '').split(' ');
      void analytics.identify(user.email, {
        firstName: firstName || undefined,
        lastName: lastNames.join(' ') || undefined,
      });
    }
  }, [user]);

  // Track the page view
  useEffect(() => {
    void analytics.page();
  }, [location]);

  return null;
}
